import { defineComponent as _defineComponent } from 'vue'
import { Input } from '@travelata-libs/ui-kit';
  import { useToast, ToastType } from '@travelata-libs/ui-kit';
  import { useQnaForm } from '../model/useQnaForm';
  import { formConfig } from '../lib/formConfig';
  import { ref } from 'vue';
  import isMobileVersion from '@/js/common/Service/isMobileVersion';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelQnaForm',
  props: {
    hotelId: null
  },
  setup(__props: any) {

const props = __props as { hotelId: number }

  

  const { formData, errors, resetForm, handleSubmit, validateForm } = useQnaForm(props.hotelId);

  const toast = useToast();

  const isMobile = !!isMobileVersion();
  const isSubmitting = ref(false);

  const submitForm = async () => {
    if (!validateForm() || isSubmitting.value) return;

    isSubmitting.value = true;
    const result = await handleSubmit();
    isSubmitting.value = false;

    toast.showToast({
      type: result.success ? ToastType.Success : ToastType.Error,
      title: '',
      description: result.success
        ? 'Вопрос отправлен'
        : 'Не удалось отправить ваш вопрос. Пожалуйста, попробуйте ещё раз',
      closable: true,
      mobile: isMobile,
    });

    if (result.success) resetForm();
  };

return { __sfc: true,props, formData, errors, resetForm, handleSubmit, validateForm, toast, isMobile, isSubmitting, submitForm, Input, formConfig }
}

})